package nl.volleyplanner.api.planner

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable
import nl.volleyplanner.api.entities.Group
import nl.volleyplanner.api.entities.PublicPerson
import nl.volleyplanner.api.types.PublicDataPayload

enum class AssigneeType {
    Person,
    Group,
    Freeform
}

@Serializable
data class TaskAssignment(
    val assigneeType: AssigneeType,
    // TODO: Make this work better
    val personAssignee: PublicPerson? = null,
    val isParent: Boolean = false,
    val groupAssignee: Group? = null,
    val freeformAssignee: String? = null,
    // TODO: Change to Instant once kotlin datetime API is stable
    val assignedAtTimestamp: LocalDateTime
) : PublicDataPayload {
    fun getAssigneeTitle() : String? {
        return when (assigneeType) {
            AssigneeType.Person -> personAssignee?.name
            AssigneeType.Group -> groupAssignee?.name
            AssigneeType.Freeform -> freeformAssignee
        }
    }
}

enum class APITaskStatus {
    Planned,
    Cancelled
}

@Serializable
data class Task(
    val id: String,
    val name: String,
    val status: APITaskStatus,
    val startDateTime: LocalDateTime?,
    val endDateTime: LocalDateTime?,
    val assignee: TaskAssignment,
    val locked: Boolean
) : PublicDataPayload